module.exports = __webpack_public_path__ + "img/1600-2_YR_2022_Lock.ec8e8c62.png";